export default defineNuxtRouteMiddleware(async (to, _from) => {
    const config = useRuntimeConfig().public.directus

    const appConfig = useAppConfig()
    const { refreshTokens } = useDirectusToken()
    const { fetchUser, setUser } = useDirectusAuth()
    const user = useDirectusUser()

    const defaultNavigationItems = appConfig?.defaultNavigationItems ? JSON.parse(JSON.stringify(appConfig?.defaultNavigationItems)) : []

    if (!user.value) {
        try {
            const user = await fetchUser()
            setUser(user.value)
        } catch (error) {
            console.error('fetchUser error', error)
        }
    }

    const authMeta = to.meta.auth || {}

    if (to.matched?.length > 0) {
        if ((authMeta?.unauthenticatedOnly && user.value) || authMeta?.requiresAuth === false) {
            return
        } else if ((authMeta?.unauthenticatedOnly && user.value) || authMeta?.requiresAuth === false) {
            // If the user should not be authenticated to access this route
            return navigateTo(authMeta?.navigateAuthenticatedTo || config.auth.redirect.home)
        } else if (to.path !== config.auth.redirect.login) {
            // If the route requires authentication
            if (!user.value) {
                try {
                    await refreshTokens().then(async (res) => {
                        if (res?.access_token) {
                            const user = await fetchUser()
                            setUser(user.value)
                        }
                    })
                } catch (error) {
                    console.error('refresh / fetchUser error', error)
                }

                return navigateTo({
                    path: config.auth.redirect.login || '/auth/login',
                    query: { redirect: to.path },
                })
                // redirect to settings if no payer_ids present for user
            } else if (!user.value?.payer_ids || user.value?.payer_ids?.length === 0) {
                if (appConfig?.tairo?.collapse?.navigation?.items) {
                    appConfig.tairo.collapse.navigation.items = []
                }

                if (to.path !== '/settings/student/add') {
                    return navigateTo({
                        path: '/settings/student/add',
                    })
                }
                return
            } else if (appConfig?.tairo?.collapse?.navigation?.items?.length === 0) {
                appConfig.tairo.collapse.navigation.items = defaultNavigationItems
            }
        }

        if (user.value?.payer_ids?.length > 0 && user.value?.needs_portal_data_validation === true) {
            if (appConfig?.tairo?.collapse?.navigation?.items) {
                appConfig.tairo.collapse.navigation.items = []
            }

            if (to.path !== '/validate-data') {
                return navigateTo({
                    path: '/validate-data',
                })
            }
        } else if (appConfig?.tairo?.collapse?.navigation?.items?.length === 0) {
            appConfig.tairo.collapse.navigation.items = defaultNavigationItems
        }
    } else {
        return
    }
})
